import { BaseService } from './BaseService';
import { FetchResult } from 'apollo-link';

// gql
import deleteBanAccountMutation from '@/graphql/mutations/bankaccount/Delete.gql';
import upsertBankAccountMutation from '@/graphql/mutations/UpsertBankAccount.gql';

import {
  BankAccountInput,
  BankAccountFields
} from '@/types/graphql/schemaTypes';

class BankAccountService extends BaseService {
  public deleteBankAccount(id: string) {
    return this.client.mutate({
      mutation: deleteBanAccountMutation,
      variables: {
        id
      }
    });
  }

  public upsertBankAccount(data: BankAccountInput, id?: string): Promise<FetchResult<BankAccountFields>> {
    return this.client.mutate({
      mutation: upsertBankAccountMutation,
      variables: {
        data,
        id
      }
    });
  }
}

export const bankAccountService = new BankAccountService();
